<digital-platform-rsx-a
  [url]="url[0].uri"
  [target]="aTarget?.value"
  klass="text-color-white text-decoration-none"
  >{{ url[0].title }}</digital-platform-rsx-a
>
